<ui-inline-svg class="spinner" [ngClass]="size()" name="spinner" aria-hidden="true"></ui-inline-svg>

@if (label(); as label) {
  <span class="spinner-label">{{ label }}</span>
}
